export default __webpack_public_path__ + "static/media/董瑞豹半身像.f39d388a.png";